export default "__VITE_ASSET__BL_h0KQ9__"